import gql from "graphql-tag";
import { estimateDetailsFields } from "../queries/getEstimate";

export const CREATE_ESTIMATE = gql`mutation createEstimate($createEstimateInput: CreateEstimateInput!) {
    createEstimate(createEstimateInput: $createEstimateInput) {
        ${estimateDetailsFields}
    }
}`;
